import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { FieldOptionsResponse, TimezoneFieldValue } from '../../../../../../api';
import { useFieldOptions } from '../../../../../../hooks';

export const useTimezone = () => {
  const { getRegionsAndTimelineOptions } = useFieldOptions();

  const { data: timezoneData } = useQuery(['DM_FIELD_OPTIONS_TZ'], () =>
    getRegionsAndTimelineOptions<FieldOptionsResponse<TimezoneFieldValue>>(['timezone'], 'TZ')
  );

  const timezoneOptions = useMemo(() => {
    const timezoneOptions = timezoneData?.data?.fields?.find((field) => field.type === 'timezone');
    return (timezoneOptions?.values || []).map((timezone) => ({
      value: timezone.key,
      label: `(${timezone.meta.offset_display}) ${timezone.meta.display_name}`,
    }));
  }, [timezoneData]);

  const mappedTimezones = Object.fromEntries(timezoneOptions.map(({ value, label }) => [value, label]));

  return {
    timezoneOptions,
    mappedTimezones,
  };
};
